import { render, staticRenderFns } from "./marcas.vue?vue&type=template&id=02c70724"
import script from "./marcas.vue?vue&type=script&lang=js"
export * from "./marcas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports